import React, { useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { isEmpty } from 'lodash';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Row, Button, Col, Form, Alert } from 'react-bootstrap';
//actions
import { loginUser } from '../../actions/users/loginUser';

//reducer
import {
  isUserAuthenticated as isUserAuthenticatedSelector,
  getLoginErrorMessage,
} from '../../selectors/users';

//components
import PageHeader from '../../components/PageHeader';
import Loading from '../../components/Loading/Loading';
import { ROUTER_BASE_PATH_MOBILE } from '../../constants/siteConstants';
import usePassword from '../../hooks/usePassword';

const LoginForm = () => {
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);
  const loginErrorMessage = useSelector(getLoginErrorMessage);
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    loginFormSubmit(data);
  };

  const [isLoading, setIsLoading] = useState(false);
  const { type, Eye } = usePassword();

  const loginFormSubmit = useCallback(
    async (data) => {
      setIsLoading(true);
      let user = {
        email: data.email,
        password: data.password,
      };
      if (!isUserAuthenticated) {
        dispatch(loginUser(user)).then((res) => !isEmpty(res.payload) && setIsLoading(false));
      }
    },
    [setIsLoading],
  );

  if (isUserAuthenticated) navigate(`${ROUTER_BASE_PATH_MOBILE}`);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <PageHeader title='Iniciar sesión' />
          <Col md='10' className='px-4 mb-5'>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group as={Row} className='mt-1 mb-1'>
                <Form.Label column sm='3'>
                  * Email:
                </Form.Label>
                <Col sm='9'>
                  <Form.Control
                    name='email'
                    type='email'
                    placeholder='Nombres'
                    {...register('email')}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className='mt-1 mb-3'>
                <Form.Label column sm='3'>
                  * Contraseña:
                </Form.Label>
                <Col sm='9'>
                  <div className='position-relative'>
                    <Form.Control
                      name='password'
                      type={type}
                      placeholder='Contraseña'
                      {...register('password')}
                    />
                    <Eye className='position-absolute end-0 top-0' />
                  </div>
                </Col>
              </Form.Group>
              {Boolean(loginErrorMessage) && <Alert variant='danger'>{loginErrorMessage}</Alert>}
              <Col className='d-flex justify-content-center mt-4'>
                <Button type='submit' className='btn btn-danger p-2'>
                  {' '}
                  Ingresar
                </Button>
                <a className='p-2'>
                  <Link className='text-black' to='/forgot-password'>
                    Olvidé mi contraseña
                  </Link>
                </a>
              </Col>
            </Form>
          </Col>
        </>
      )}
    </>
  );
};

LoginForm.defaultProps = {
  loginErrorMessage: null,
};

export default LoginForm;
